:host {
    display: block;
    border-bottom: 1px solid #e2e2e2;
    padding-top: 90px;
}

:host([variant="nimbus"]) {
    background-color: #fff;

    .container {
        padding: 0;
    }

    .image {
        max-width: 180px;
    }

    @media (max-width: 600px) {
        .image {
            width: 0;
        }

        .image img {
            display: none;
        }
    }

    ::slotted([slot="title"]) {
        font-size: 18px !important;
        margin-top: 15px !important;
    }

    ::slotted([slot="sub-title"]) {
        margin-bottom: 10px;
    }

    ::slotted(a[slot="details"]) {
        color: #005074 !important;
        text-decoration: underline !important;
    }

    ::slotted(a[slot="details"]:hover) {
        color: #131313 !important;
    }

    ::slotted(a[slot="details"]:last-child) {
        margin-bottom: 10px !important;
    }
}

:host(:first-child) {
    padding-top: 0;
}

.container {
    padding: 25px 0;
    display: flex;
    gap: 25px;
}

.image {
    max-width: 160px;
    width: 18vw;
    display: flex;
}

.image img {
    display: block;
    width: 100%;
    height: auto;
}

.image ux-icon {
    font-size: 18vw;

    @media (min-width: 890px) {
        font-size: 160px;
    }
}

::slotted {
    font-family: "Frutiger-Light", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
}

::slotted([slot="title"]) {
    font-size: 20px;
}

::slotted([slot="sub-title"]) {
    font-size: 15px;
}

::slotted([slot="sub-title"]),
::slotted([slot="text"]),
::slotted([slot="details"]) {
    color: #727272;
    display: block;
}

::slotted([slot="details"]) {
    margin-bottom: 5px;
}

::slotted(a[slot="details"]) {
    margin-bottom: 5px;
    transition: color 0.5s ease;
    text-decoration: none !important;
}

::slotted(a[slot="details"]:hover) {
    color: #131313;
}
